import React from 'react';
import PropTypes from 'prop-types';
import { getBrowserTimeZone } from 'helpers/dateTimeHelper';

// A handful of common zones for browsers old enough to lack
// Intl.supportedValuesOf -- not exhaustive, just enough to keep the picker
// usable everywhere.
var FALLBACK_TIME_ZONES = [
  'UTC',
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Los_Angeles',
  'America/Anchorage',
  'Pacific/Honolulu',
  'America/Toronto',
  'America/Sao_Paulo',
  'Europe/London',
  'Europe/Paris',
  'Europe/Berlin',
  'Europe/Moscow',
  'Africa/Cairo',
  'Africa/Johannesburg',
  'Asia/Dubai',
  'Asia/Kolkata',
  'Asia/Shanghai',
  'Asia/Tokyo',
  'Asia/Singapore',
  'Australia/Sydney',
  'Pacific/Auckland',
];

// Intl.supportedValuesOf is missing in older browsers (and in this suite's
// Node 16 test runtime), so the feature-detect must not throw.
function getTimeZoneOptions() {
  if (typeof Intl !== 'undefined' && typeof Intl.supportedValuesOf === 'function') {
    try {
      var zones = Intl.supportedValuesOf('timeZone');
      if (zones && zones.length) return zones;
    } catch (e) {
      // fall through to the hardcoded list below
    }
  }
  return FALLBACK_TIME_ZONES;
}

var TIME_ZONE_OPTIONS = getTimeZoneOptions();

// Last row of the Schedule card: the zone the rule is read in. Its own component so the Early
// Submission Window row can sit between the cadence and the zone without CadenceEditor knowing.
var TimeZoneEditor = function (props) {
  var timeZone = props.timeZone || getBrowserTimeZone();
  var onChange = props.onChange;
  var t = props.t;
  var errors = props.errors || {};

  var handleTimeZoneChange = function (e) {
    onChange({ timeZone: e.target.value });
  };

  return (
    <div className="inspect-recurrence-grid-row">
      <label className="inspect-recurrence-grid-label" htmlFor="inspect-time-zone">
        {t('inspect:recurrenceTimeZoneLabel')}
      </label>
      <div className="inspect-recurrence-grid-control">
        <select
          id="inspect-time-zone"
          className={'inspect-recurrence-select' + (errors.scheduledRecurrenceTimeZone ? ' has-error' : '')}
          value={timeZone}
          onChange={handleTimeZoneChange}
          aria-label={t('inspect:recurrenceTimeZoneLabel')}
        >
          {TIME_ZONE_OPTIONS.map(function (zone) {
            return (
              <option key={zone} value={zone}>
                {zone}
              </option>
            );
          })}
        </select>
        {errors.scheduledRecurrenceTimeZone && (
          <div className="slate-text-input-error">{errors.scheduledRecurrenceTimeZone}</div>
        )}
        <p className="inspect-mode-hint inspect-recurrence-grid-hint">{t('inspect:recurrenceTimeZoneHint')}</p>
      </div>
    </div>
  );
};

TimeZoneEditor.propTypes = {
  timeZone: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  errors: PropTypes.object,
};

export default TimeZoneEditor;
